import products from '../content/products.json';

const productMap = products.results.reduce((acc, product) => {
    acc[product.id.toLowerCase()] = product;
    return acc;
}, {});

const unknownProduct = { title: 'Unknown' };

export const getProductName = (id) => (productMap[id.toLowerCase()] || unknownProduct).title;